var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1cb79e;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-471 -2209)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(471 2209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.237,9,12.011,23.427,6,16.87",
    transform: "translate(475.5 2212.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckIcon);
export default __webpack_public_path__ + "static/media/green-check-icon.4eadc7b495b9b9d9be85b829eb8cfe63.svg";
export { ForwardRef as ReactComponent };